/* Early Black Friday 2026 sale page: colour swatches and Add to cart on ebf-products cards. */
(function () {
  if (window.lpEbf) return;
  window.lpEbf = true;

  function initCards(root) {
    root.querySelectorAll('[data-ebf-card]:not([data-ebf-ready])').forEach(function (card) {
      card.setAttribute('data-ebf-ready', '');
      var dataEl = card.querySelector('[data-ebf-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var photos = card.querySelectorAll('.ebf-card__photo[data-color]');
      var swatches = card.querySelectorAll('.ebf-swatch');
      var nameEl = card.querySelector('[data-ebf-color-name]');
      var priceEl = card.querySelector('[data-ebf-price]');
      var compareEl = card.querySelector('[data-ebf-compare]');
      var badge = card.querySelector('[data-ebf-badge]');
      var pctEl = card.querySelector('[data-ebf-pct]');
      var addBtn = card.querySelector('[data-ebf-add]');
      var links = card.querySelectorAll('[data-ebf-link]');
      var current = null;

      function byId(id) { for (var i = 0; i < data.variants.length; i++) { if (data.variants[i].id === id) return data.variants[i]; } return data.variants[0]; }
      function forColor(color) {
        var first = null;
        for (var i = 0; i < data.variants.length; i++) {
          var x = data.variants[i];
          if (x.color !== color) continue;
          if (x.available) return x;
          if (!first) first = x;
        }
        return first;
      }
      function select(v) {
        if (!v) return;
        current = v;
        swatches.forEach(function (sw) { sw.setAttribute('aria-checked', sw.getAttribute('data-color') === v.color ? 'true' : 'false'); });
        photos.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-color') === v.color); });
        if (nameEl && v.color) nameEl.textContent = v.color;
        if (priceEl) priceEl.textContent = v.priceText;
        var onSale = v.compare > v.price;
        if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = v.compareText; }
        if (badge) {
          badge.hidden = !onSale;
          if (onSale && pctEl) pctEl.textContent = Math.round((v.compare - v.price) * 100 / v.compare);
        }
        links.forEach(function (a) { a.setAttribute('href', v.url); });
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
        }
        if (card._showQty) card._showQty();
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () { select(forColor(sw.getAttribute('data-color'))); });
      });
      select(byId(data.selected));

      if (addBtn) {
        // after the first add the button becomes "− n +" with the number in the cart (Hrach, 30 Oct)
        var qty = stepper({ cls: 'ebf-qty--card', min: 0, max: 10, value: 1, onChange: function (v) {
          qty.busy();
          setCartQty(current.id, v).then(showQty).catch(function () { showQty(); });
        } });
        qty.hidden = true;
        addBtn.parentNode.insertBefore(qty, addBtn.nextSibling);
        var showQty = function () {
          var n = current ? qtyInCart(current.id) : 0;
          addBtn.hidden = n > 0; qty.hidden = n === 0;
          if (n) qty.set(n);
        };
        card._showQty = showQty;
        addBtn.addEventListener('click', function () {
          if (!current || !current.available) return;
          addBtn.disabled = true;
          setCartQty(current.id, qtyInCart(current.id) + 1)
            .then(function () { addBtn.disabled = false; showQty(); })
            .catch(function (err) {
              addBtn.disabled = false;
              addBtn.textContent = (err && err.description) || addBtn.getAttribute('data-label-add');
            });
        });
        loadCart().then(showQty);
      }
    });
  }

  /* ---------- 10% OFF tag on the mouse (V6 hero file, modelled on wepresent.wetransfer.com) ----------
     Follows the pointer with a damped spring and swings from its top-left hinge; shown over [data-ebf-tag-zone]
     sections, folds up (rotateX -90) over links and buttons or outside the zones. Desktop with a mouse only. */
  function initCursor() {
    var tag = document.querySelector('[data-ebf-cursor]');
    if (!tag || tag.hasAttribute('data-ready')) return;
    tag.setAttribute('data-ready', '');
    document.body.appendChild(tag);
    var fine = matchMedia('(hover:hover) and (pointer:fine)'), still = matchMedia('(prefers-reduced-motion: reduce)');
    var OFF = 18, POS = 12, SWING = 14, FLIP = 11, SW_Y = 0.04, SW_X = 0.01, SW_MAX = 30;
    var px = -999, py = -999, x = 0, y = 0, vx = 0, vy = 0, rz = 0, vrz = 0, fx = -90, vfx = 0, fT = -90, mode = 'off', last = 0, raf = 0;
    function clamp(v, m) { return Math.max(-m, Math.min(m, v)); }
    function spring(p, v, tg, w, dt) { v += (w * w * (tg - p) - 2 * w * v) * dt; return [p + v * dt, v]; }
    function show() { if (mode === 'off') { x = px + OFF; y = py + OFF; vx = vy = 0; rz = vrz = 0; } mode = 'follow'; fT = 0; }
    function hide() { if (mode !== 'off') { mode = 'fold'; fT = -90; } }
    function evaluate(el) {
      if (!fine.matches || !el || !el.closest) return;
      var zone = el.closest('[data-ebf-tag-zone]'), btn = el.closest('a, button, input, select, label');
      (zone && !btn) ? show() : hide();
      kick();
    }
    function frame(now) {
      var dt = Math.min(0.033, ((now - (last || now)) / 1000) || 1 / 60); last = now;
      var tx = px + OFF, ty = py + OFF, r;
      if (still.matches) { x = tx; y = ty; rz = 0; fx = fT; }
      else {
        r = spring(x, vx, tx, POS, dt); x = r[0]; vx = r[1];
        r = spring(y, vy, ty, POS, dt); y = r[0]; vy = r[1];
        r = spring(rz, vrz, clamp(-(vy * SW_Y + vx * SW_X), SW_MAX), SWING, dt); rz = r[0]; vrz = r[1];
        r = spring(fx, vfx, fT, FLIP, dt); fx = r[0]; vfx = r[1];
      }
      if (mode === 'fold' && fx <= -89.5) { mode = 'off'; fx = -90; vfx = 0; }
      tag.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) rotateZ(' + rz.toFixed(3) + 'deg) perspective(100px) rotateX(' + Math.min(0, fx).toFixed(3) + 'deg)';
      var busy = mode !== 'off' && (Math.abs(tx - x) > .05 || Math.abs(ty - y) > .05 || Math.abs(vx) + Math.abs(vy) > 1 || Math.abs(rz) > .02 || Math.abs(vrz) > .05 || Math.abs(fT - fx) > .05 || Math.abs(vfx) > .05);
      if (busy) raf = requestAnimationFrame(frame); else { raf = 0; last = 0; }
    }
    function kick() { if (!raf) raf = requestAnimationFrame(frame); }
    addEventListener('pointermove', function (e) { if (e.pointerType !== 'mouse') return; px = e.clientX; py = e.clientY; evaluate(e.target); }, { passive: true });
    addEventListener('scroll', function () { if (px > -999) evaluate(document.elementFromPoint(px, py)); }, { passive: true });
    document.documentElement.addEventListener('pointerleave', function () { hide(); kick(); });
  }

  /* ---------- Gift grid: tiles start scattered and lock into the grid on scroll (V6 hero file) ---------- */
  function initAssemble(root) {
    root.querySelectorAll('[data-ebf-assemble]:not([data-ready])').forEach(function (grid) {
      grid.setAttribute('data-ready', '');
      var tiles = Array.prototype.slice.call(grid.children);
      if (!tiles.length) return;
      var still = matchMedia('(prefers-reduced-motion: reduce)');
      var S = [[.10, -.04, -10], [.41, 1.08, 6], [.71, .02, 9], [.25, 1.02, 7], [.52, -.10, -5], [.85, 1.12, -8], [.32, .06, 11], [.63, 1.00, -12], [.92, -.06, 6], [.18, .5, 4], [.5, .55, -6], [.78, .5, 8]];
      var P = [[-.28, -.38, -9], [.18, -.2, 7], [.32, -.42, 12], [-.36, .08, 6], [.1, .22, -5], [.38, .04, -11], [-.2, .36, 10], [.06, .4, -7], [.3, .26, 8], [-.1, -.3, 5], [.2, .3, -6], [-.3, .2, 7]];
      var geo = null, cur = 0, last = 0, raf = 0;
      function clamp01(v) { return Math.max(0, Math.min(1, v)); }
      function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      function measure() {
        tiles.forEach(function (el) { el.style.transform = ''; });
        var sec = grid.closest('section') || grid.parentElement, sr = sec.getBoundingClientRect(), W = sr.width, wide = W >= 900;
        var g0 = grid.getBoundingClientRect().top - sr.top;
        geo = { wide: wide, gTop: grid.getBoundingClientRect().top + scrollY, items: tiles.map(function (el, i) {
          var r = el.getBoundingClientRect(), t = r.width, tx = r.left - sr.left, ty = r.top - sr.top, sx, sy, rot;
          if (wide) { var s = S[i % S.length]; sx = Math.min(W - t - 12, Math.max(12, W * s[0] - t / 2)); sy = g0 + s[1] * t; rot = s[2]; }
          else { var q = P[i % P.length]; sx = tx + q[0] * t; sy = ty + q[1] * t; rot = q[2]; }
          return { dx: sx - tx, dy: sy - ty, rot: rot };
        }) };
      }
      function target() {
        if (still.matches) return 1;
        var top = grid.getBoundingClientRect().top, a = innerHeight * (geo.wide ? .95 : 1), b = innerHeight * (geo.wide ? .4 : .5);  /* locked once the grid top is 40% down the screen */
        return clamp01((a - top) / (a - b));
      }
      function draw(p) {
        geo.items.forEach(function (it, i) {
          var e = ease(clamp01((p - (i % 2 ? (i + 4) : i) * 0.022) / 0.64)), k = 1 - e;
          tiles[i].style.transform = e >= 1 ? '' : 'translate3d(' + (it.dx * k).toFixed(1) + 'px,' + (it.dy * k).toFixed(1) + 'px,0) rotate(' + (it.rot * k).toFixed(2) + 'deg)';
          tiles[i].style.boxShadow = e < 1 ? '0 ' + (18 * k).toFixed(1) + 'px ' + (40 * k).toFixed(1) + 'px rgba(0,0,0,' + (.22 * k).toFixed(3) + ')' : '';
          tiles[i].style.zIndex = e < 1 ? (i % 2 ? 2 : 1) : '';
        });
      }
      function frame(now) {
        var dt = Math.min(.05, ((now - (last || now)) / 1000) || 1 / 60); last = now;
        var tg = target(); cur += (tg - cur) * (1 - Math.exp(-7 * dt));
        if (Math.abs(tg - cur) < .0005) cur = tg;
        draw(cur);
        if (cur !== tg) raf = requestAnimationFrame(frame); else { raf = 0; last = 0; }
      }
      function kick() { if (!raf) raf = requestAnimationFrame(frame); }
      function reset() { measure(); cur = target(); draw(cur); }
      reset();
      addEventListener('scroll', kick, { passive: true });
      addEventListener('resize', reset);
      if (document.fonts) document.fonts.ready.then(reset);
      addEventListener('load', reset);
    });
  }

  /* ---------- Videos play only while on screen ---------- */
  function initVideos(root) {
    var vids = root.querySelectorAll('video.ebf-collage__video:not([data-ready])');
    if (!vids.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.preload = 'auto'; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
      });
    }, { rootMargin: '200px 0px' }) : null;
    vids.forEach(function (v) { v.setAttribute('data-ready', ''); v.muted = true; v.playsInline = true; if (io) io.observe(v); else v.play(); });
  }

  /* ---------- shared by the setup builder and the bundles: money, variants, colour swatches, cart ---------- */
  function money(cents, fmt) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, n.split('.')[0]).replace(/\{\{\s*amount\s*\}\}/, n).replace(/<[^>]+>/g, '');
  }
  function variantById(p, id) { for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].id === id) return p.variants[i]; } return p.variants[0]; }
  function variantForColor(p, color) {
    var best = null;
    p.variants.forEach(function (v) { if (v.color === color && (!best || (!best.available && v.available))) best = v; });
    return best;
  }
  function anyAvailable(p) { return p.variants.some(function (v) { return v.available; }); }
  function regular(v) { return v.compare > v.price ? v.compare : v.price; }
  // whole saving against the regular price, as a whole number: 20.1 -> 20, 18.5 -> 19 (Hrach, 2 Nov)
  function savedPct(reg, pay) {
    if (!(reg > pay)) return 0;
    var x = (reg - pay) * 100 / reg;
    if (Math.abs(x - 23.5) < 0.01) return '23';   // the extra-15% tier is 23.5% in total; we say 23% (Hrach, 3 Nov)
    return String(Math.round(x));
  }
  // the real saving, to one decimal, so a shopper's own sum (regular price x (1 - %)) matches the price shown:
  // 18.95 -> 19, 23.49 -> 23.5, 10.06 -> 10 (Hrach, 4 Nov). Used in the builder text; stickers and tiles stay whole numbers.
  function realPct(reg, pay) {
    if (!(reg > pay)) return '0';
    var r = Math.round((reg - pay) * 1000 / reg) / 10;
    return r % 1 === 0 ? String(r) : r.toFixed(1);
  }
  // The only discount numbers shown (Hrach, 4 Nov): 10 (any order), 19 ($600+), 23 ($1,200+), from the tier the sale
  // total reaches: 100 - (100 - base) x (100 - extra) / 100, rounded down (23.5 -> 23).
  function tierLabel(sale, t1, t2, base, p1, p2) {
    var ex = sale >= t2 ? p2 : (sale >= t1 ? p1 : 0), b = isNaN(base) ? 10 : base;
    return String(Math.floor(100 - (100 - b) * (100 - ex) / 100 + 1e-9));
  }
  function setImg(img, v) { if (!img || !v.image) return; img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = v.image; }
  // Fills `el` with one photo swatch per colour (as on the product page) under a "Color: …" line.
  // onPick(variant) runs on click. Returns update(variant) to move the selection.
  function swatches(el, p, v, onPick) {
    if (!el) return function () {};
    if (!p.colors || p.colors.length < 2) { el.hidden = true; return function () {}; }
    el.innerHTML = ''; el.hidden = false;
    var label = document.createElement('p'); label.className = 'ebf-swatches__label';
    label.innerHTML = 'Color: <span></span>';
    var name = label.querySelector('span');
    var row = document.createElement('div'); row.className = 'ebf-swatches__row'; row.setAttribute('role', 'radiogroup');
    p.colors.forEach(function (c) {
      var cv = variantForColor(p, c.name), ok = !!(cv && cv.available);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ebf-swatch' + (ok ? '' : ' ebf-swatch--soldout'); b.disabled = !ok;
      b.setAttribute('role', 'radio'); b.title = c.name; b.setAttribute('data-color', c.name);
      b.setAttribute('aria-label', c.name + (ok ? '' : ', sold out'));
      b.style.setProperty('--sw', c.css);
      b.innerHTML = c.image ? '<img src="' + c.image + '" alt="" loading="lazy">' : '<i></i>';
      b.addEventListener('click', function (e) { e.stopPropagation(); if (cv) onPick(cv); });
      row.appendChild(b);
    });
    el.appendChild(label); el.appendChild(row);
    function update(nv) {
      row.querySelectorAll('.ebf-swatch').forEach(function (b) { b.setAttribute('aria-checked', b.getAttribute('data-color') === nv.color ? 'true' : 'false'); });
      name.textContent = nv.color || '';
    }
    update(v);
    return update;
  }
  function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function postJSON(path, body) {
    return fetch(shopRoot() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  // list: variant ids, or { id, quantity } items
  function addToCart(list) {
    return postJSON('cart/add.js', { items: list.map(function (x) { return typeof x === 'object' ? x : { id: x, quantity: 1 }; }) })
      .then(function (j) { noteAdded(j); return j; });
  }

  /* ---------- what is in the cart (variant id -> line key and quantity), so steppers show real numbers ---------- */
  var cartQty = {}, cartLoad = null;
  function readCart(c) { cartQty = {}; (c.items || []).forEach(function (i) { var e = cartQty[i.variant_id]; if (e) e.qty += i.quantity; else cartQty[i.variant_id] = { key: i.key, qty: i.quantity }; }); }
  function noteAdded(j) { (j.items || []).forEach(function (i) { cartQty[i.variant_id] = { key: i.key, qty: i.quantity }; }); }
  function loadCart() {
    return cartLoad || (cartLoad = fetch(shopRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(readCart).catch(function () {}));
  }
  function qtyInCart(id) { return (cartQty[id] && cartQty[id].qty) || 0; }
  // sets one variant's quantity in the cart (adds it when it is not there yet); resolves with the new quantity
  function setCartQty(id, qty) {
    var e = cartQty[id];
    var req = e ? postJSON('cart/change.js', { id: e.key, quantity: qty }).then(readCart)
                : postJSON('cart/add.js', { items: [{ id: id, quantity: qty }] }).then(noteAdded);
    return req.then(function () { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); return qtyInCart(id); });
  }

  /* ---------- "− n +" quantity stepper ---------- */
  var ICON_MINUS = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"/></svg>';
  // opts: cls, min (lowest the minus goes to), max, value, onChange(newValue)
  function stepper(opts) {
    var el = document.createElement('div'), min = opts.min || 0, max = opts.max || 10, n = 0;
    el.className = 'ebf-qty' + (opts.cls ? ' ' + opts.cls : '');
    el.innerHTML = '<button type="button" class="ebf-qty__btn" data-step="-1" aria-label="One fewer">' + ICON_MINUS + '</button>' +
      '<span class="ebf-qty__n" aria-live="polite"></span>' +
      '<button type="button" class="ebf-qty__btn" data-step="1" aria-label="One more">' + ICON_PLUS + '</button>';
    var nEl = el.querySelector('.ebf-qty__n'), bs = el.querySelectorAll('button');
    function set(v) { n = v; nEl.textContent = v; bs[0].disabled = v <= min; bs[1].disabled = v >= max; el.classList.remove('is-busy'); }
    bs.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = n + +b.getAttribute('data-step');
        if (v < min || v > max || el.classList.contains('is-busy')) return;
        opts.onChange(v);
      });
    });
    el.set = set; el.get = function () { return n; };
    el.busy = function () { el.classList.add('is-busy'); };
    set(opts.value == null ? 1 : opts.value);
    return el;
  }
  function openDrawer() {
    var toggle = document.querySelector('.js-cart-drawer-toggle');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
  }

  /* ---------- "Create your own bundle" section (#build) with a volume-style meter ---------- */
  function initBuilder() {
    var dlg = document.querySelector('[data-ebf-builder]');
    if (!dlg || dlg.hasAttribute('data-ready')) return;
    dlg.setAttribute('data-ready', '');
    var data; try { data = JSON.parse(dlg.querySelector('[data-ebf-bd-data]').textContent); } catch (e) { return; }
    var t1 = +dlg.getAttribute('data-tier1'), t2 = +dlg.getAttribute('data-tier2');
    var l1 = dlg.getAttribute('data-t1-label'), l2 = dlg.getAttribute('data-t2-label');
    var toCheckout = dlg.getAttribute('data-checkout') === 'true';
    var tiles3 = dlg.querySelectorAll('[data-t3]'), fills = dlg.querySelectorAll('[data-fill]'), wasOn = [true, false, false];
    var status = dlg.querySelector('[data-ebf-bd-status]'), totalEl = dlg.querySelector('[data-ebf-bd-total]');
    var step1 = dlg.querySelector('[data-ebf-bd-step="1"]'), step2 = dlg.querySelector('[data-ebf-bd-step="2"]');
    var addsEl = dlg.querySelector('[data-ebf-bd-adds]'), addBtn = dlg.querySelector('[data-ebf-bd-add]');
    var startText = status.textContent, main = null, picked = [];
    var d = dlg.dataset, p1 = +d.pct1, p2 = +d.pct2;
    var badge = dlg.querySelector('[data-ebf-bd-badge]'), badgePct = dlg.querySelector('[data-ebf-bd-pct]'), badgeWord = dlg.querySelector('[data-ebf-bd-word]');
    var wasEl = dlg.querySelector('[data-ebf-bd-was]');
    var mainV = data.mains.map(function (m) { return variantById(m.product, m.product.selected); });
    var uid = 0, shown = {}, minePanel = dlg.querySelector('[data-ebf-bd-mine]'), mineList = dlg.querySelector('[data-ebf-bd-minelist]');
    var pageMode = dlg.dataset.autostart === 'true';

    var tierPct = 0, rowTier = d.basePct;
    function linePay(e) { return Math.round(e.v.price * e.qty * (100 - tierPct) / 100); }
    function lines() { return (main ? [main] : []).concat(picked); }
    function total() { var s = 0; lines().forEach(function (a) { s += a.v.price * a.qty; }); return s; }
    function render() {
      var sum = total();
      // locked / unlocked tiles and the line that fills as the bundle grows (Figma 2269-9824)
      var f = [Math.min(1, sum / t1), sum < t1 ? 0 : Math.min(1, (sum - t1) / (t2 - t1)), sum < t2 ? 0 : Math.min(1, (sum - t2) / 30000)];
      fills.forEach(function (el, k) { el.style.transform = 'scaleX(' + f[k] + ')'; });
      [sum >= t1, sum >= t2].forEach(function (on, k) {
        var tile = tiles3[k]; if (!tile) return;
        tile.classList.toggle('is-on', on);
        if (on && !wasOn[k + 1]) { tile.classList.remove('pop'); void tile.offsetWidth; tile.classList.add('pop'); }
        wasOn[k + 1] = on;
      });
      dlg.classList.toggle('is-t1', sum >= t1); dlg.classList.toggle('is-t2', sum >= t2);
      // sticker: the sale's 10% OFF until a tier is reached, then +10 / +15 EXTRA; price after the extra, regular struck through
      var pct = sum >= t2 ? p2 : (sum >= t1 ? p1 : 0), pay = 0, reg = 0;
      tierPct = pct;
      // each line is priced after the tier's extra discount, like Shopify does at checkout, so every row (regular price
      // struck, price you pay) and the total add up and a shopper's own check (regular x (1 - %)) lands on the same number
      lines().forEach(function (a) { reg += regular(a.v) * a.qty; pay += linePay(a); });
      // sticker: the whole saving so far (sale price and extra together), 10% OFF before anything is picked
      var off = lines().length ? savedPct(reg, pay) : d.basePct, real = lines().length ? tierLabel(sum, t1, t2, parseFloat(d.basePct), p1, p2) : d.basePct;
      rowTier = real;
      badge.hidden = !+off;
      badgePct.textContent = off; badgeWord.textContent = d.baseWord;
      dlg.classList.toggle('has-extra', !!pct);
      dlg.classList.toggle('has-pick', lines().length > 0);
      totalEl.textContent = money(pay, data.money);
      wasEl.hidden = !(reg > pay); wasEl.textContent = money(reg, data.money);
      var t1pct = +d.tile1, t2pct = +d.tile2;
      function say(tpl, amount, pctNow, next) {
        return esc(tpl).replace('[amount]', '<b>' + money(amount, data.money) + '</b>').replace('[pct]', '<b>' + pctNow + '</b>').replace('[next]', next);
      }
      if (!lines().length) status.textContent = startText;
      // the % in the text is the real saving so far; the tiles above say the most each tier gives (Hrach, 3 Nov)
      else if (sum < t1) status.innerHTML = say(d.pg0, t1 - sum, real, t1pct);
      else if (sum < t2) status.innerHTML = say(d.pg1, t2 - sum, real, t2pct);
      else status.innerHTML = say(d.pg2, 0, real, t2pct);
      addBtn.disabled = !lines().length || lines().some(function (a) { return !a.v.available; });
      renderMine();
    }
    function tile(cls, p, v, onToggle, onColor) {
      var t = document.createElement('div'); t.className = cls;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ebf-bd__pick'; b.disabled = !anyAvailable(p);
      b.innerHTML = '<span class="ebf-bd__img">' + (v.image ? '<img src="' + v.image + '" alt="">' : '') + '</span>' +
        '<span class="ebf-bd__name">' + p.title + '</span><span class="ebf-bd__price">' + money(v.price, data.money) + '</span>' +
        '<span class="ebf-bd__tick" aria-hidden="true"></span>';
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', onToggle);
      var sw = document.createElement('div'); sw.className = 'ebf-swatches ebf-bd__sw';
      t.appendChild(b); t.appendChild(sw);
      t._update = swatches(sw, p, v, onColor);
      return t;
    }
    function paint(el, v) {
      setImg(el.querySelector('.ebf-bd__img img'), v);
      el.querySelector('.ebf-bd__price').textContent = money(v.price, data.money);
    }
    // ---- the bundle so far: every picked product (the main speaker too) with photo in its colour, name, price and "− n +" ----
    var syncQ = null;   // product page: writes the main speaker's quantity back into the page's quantity box
    function setEntryQty(e, n) {
      e.qty = n;
      if (e === main && syncQ) syncQ(n);
      if (n === 0) {
        delete shown[e.id];
        if (e === main) { main = null; showStep1(); }
        else { var at = picked.indexOf(e); if (at > -1) picked.splice(at, 1); }
      } else if (e !== main && picked.indexOf(e) < 0) picked.push(e);
      if (e.sync) e.sync();
      render();
    }
    function showStep1() { if (pageMode) return; step2.hidden = true; step1.hidden = false; }
    function renderMine() {
      var list = lines(); minePanel.hidden = !list.length;
      mineList.innerHTML = '';
      list.forEach(function (e) {
        var row = document.createElement('div'); row.className = 'ebf-mine__t';
        if (!shown[e.id]) { shown[e.id] = true; row.classList.add('is-new'); }
        var lp = linePay(e), was = regular(e.v) * e.qty > lp ? ' <s>' + money(regular(e.v) * e.qty, data.money) + '</s>' : '';
        row.innerHTML = '<span class="ebf-mine__img">' + (e.v.image ? '<img src="' + e.v.image + '" alt="">' : '') + '</span>' +
          '<span class="ebf-mine__txt"><b>' + esc(e.p.title) + '</b><span class="ebf-mine__price">' + money(lp, data.money) + was + '</span></span>';
        var q = stepper({ cls: 'ebf-qty--row ebf-qty--dark', min: (e === main && pageMode) ? 1 : 0, max: 10, value: e.qty, onChange: function (v) { setEntryQty(e, v); } });
        // the row's saving sits top right, level with the name, above the quantity (Hrach, 4 Nov)
        var side = document.createElement('div'); side.className = 'ebf-mine__side';
        if (regular(e.v) * e.qty > lp) side.innerHTML = '<span class="ebf-mine__off">' + rowTier + '% off</span>';
        side.appendChild(q); row.appendChild(side); mineList.appendChild(row);
      });
    }
    function esc(t) { var x = document.createElement('span'); x.textContent = t; return x.innerHTML; }
    function pickMain(i, quiet) {
      main = { id: ++uid, p: data.mains[i].product, v: mainV[i], qty: 1 };
      picked.forEach(function (e) { e.sync = null; });   // add-ons already in the bundle stay; their tiles are re-linked below
      addsEl.innerHTML = '';
      data.mains[i].adds.forEach(function (a) {
        var entry = picked.filter(function (e) { return e.p.title === a.title; })[0] || { id: ++uid, p: a, v: variantById(a, a.selected), qty: 0 }, t, q;
        entry.sync = function () {
          t.classList.toggle('is-on', entry.qty > 0); t.querySelector('.ebf-bd__pick').setAttribute('aria-pressed', entry.qty > 0 ? 'true' : 'false');
          q.hidden = entry.qty === 0; if (entry.qty) q.set(entry.qty);
          addOne.hidden = entry.qty > 0; addOne.disabled = !entry.v.available;
          paint(t, entry.v); t._update(entry.v);
        };
        // picking a colour only changes the colour; the "Add" button puts it in the bundle (Hrach, 3 Nov)
        t = tile('ebf-bd__addon', a, entry.v, function () { setEntryQty(entry, entry.qty ? 0 : 1); },
          function (v) { entry.v = v; entry.sync(); if (entry.qty) render(); });
        // the number shows once the add-on is in the bundle (Hrach, 30 Oct)
        q = stepper({ cls: 'ebf-qty--dark', min: 0, max: 10, value: Math.max(1, entry.qty), onChange: function (v) { setEntryQty(entry, v); } });
        q.hidden = true; t.appendChild(q);
        var addOne = document.createElement('button'); addOne.type = 'button';
        addOne.className = 'ebf-btn ebf-btn--red ebf-bd__addone'; addOne.textContent = d.addOne || 'Add';
        addOne.addEventListener('click', function () { setEntryQty(entry, 1); });
        t.appendChild(addOne);
        addsEl.appendChild(t); entry.sync();
      });
      step1.hidden = true; step2.hidden = false; render();
      if (quiet) return;
      var top = minePanel.getBoundingClientRect().top;
      if (top < 0 || top > innerHeight * .6) minePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    dlg.querySelectorAll('[data-ebf-bd-main]').forEach(function (t) {
      var i = +t.getAttribute('data-ebf-bd-main'), p = data.mains[i] && data.mains[i].product;
      if (!p) return;
      var update = swatches(t.querySelector('[data-ebf-bd-sw]'), p, mainV[i], function (v) { mainV[i] = v; update(v); paint(t, v); });
      t.querySelector('[data-ebf-bd-pick]').addEventListener('click', function () { pickMain(i); });
    });
    dlg.querySelector('[data-ebf-bd-back]').addEventListener('click', function () { if (main) { delete shown[main.id]; } main = null; showStep1(); render(); });
    addBtn.addEventListener('click', function () {
      if (!lines().length) return;
      addBtn.disabled = true;
      addToCart(lines().map(function (a) { return { id: a.v.id, quantity: a.qty }; }))
        .then(function () {
          addBtn.textContent = addBtn.getAttribute('data-added');
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
          if (toCheckout) {
            location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';
            setTimeout(function () { addBtn.textContent = addBtn.getAttribute('data-label'); render(); }, 8000);  // if checkout never opens
            return;
          }
          setTimeout(function () { addBtn.textContent = addBtn.getAttribute('data-label'); addBtn.disabled = false; openDrawer(); }, 700);
        })
        .catch(function (err) { addBtn.disabled = false; status.textContent = (err && err.description) || 'Could not add to cart.'; });
    });
    // product page: start from the page's product and follow the colour picked on the page
    if (d.autostart === 'true' && data.mains.length) {
      pickMain(0, true);
      var pageVariant = function () {
        var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        return f ? +f.value : 0;
      };
      var lastId = pageVariant();
      setInterval(function () {
        var id = pageVariant();
        if (!id || id === lastId) return;
        lastId = id;
        var v = data.mains[0].product.variants.filter(function (x) { return x.id === id; })[0];
        if (v && main) { main.v = v; render(); }
      }, 600);
      // the page's quantity box sets the main speaker's quantity in the builder, and the other way round (Hrach, 4 Nov:
      // the page's own Add to cart is hidden, the builder's button adds everything)
      var qIn = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if (qIn && main) {
        var lastQ = parseInt(qIn.value, 10) || 1;
        syncQ = function (n) { lastQ = n; qIn.value = n < 10 ? '0' + n : String(n); };
        if (lastQ !== main.qty) setEntryQty(main, Math.min(10, lastQ));
        setInterval(function () {
          var n = Math.max(1, Math.min(10, parseInt(qIn.value, 10) || 1));
          if (n !== lastQ) { lastQ = n; if (main && main.qty !== n) setEntryQty(main, n); }
        }, 400);
      }
    }
    // The Add to cart bar sticks to the bottom only while the tier block is pinned at the top (Hrach, 4 Nov: on phones it
    // used to float over the heading as the builder came in, and the tier block slid over it on the way out)
    var liveEl = dlg.querySelector('[data-ebf-bd-live]'), dockTick = false;
    function dock() {
      dockTick = false;
      if (!liveEl) return;
      var topVar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ebf-top')) || 0;
      var r = liveEl.getBoundingClientRect(), body = liveEl.parentElement.getBoundingClientRect();
      dlg.classList.toggle('is-docked', r.top <= topVar + 1 && body.bottom > r.bottom + 60);
    }
    function dockSoon() { if (!dockTick) { dockTick = true; requestAnimationFrame(dock); } }
    addEventListener('scroll', dockSoon, { passive: true }); addEventListener('resize', dockSoon); dock();
    // coming back from checkout with the browser's back button restores the page as it was: free the button again
    addEventListener('pageshow', function (e) { if (e.persisted) { addBtn.textContent = addBtn.getAttribute('data-label'); render(); } });
    render();
  }

  /* ---------- Ready-made bundles: colour per product, regular price struck through, price after the extra tier
     discount (tier 2 replaces tier 1, as in the November offer calculator sheet); adds every product as its own line ---------- */
  function initBundles(root) {
    root.querySelectorAll('[data-ebf-bundle-card]:not([data-ready])').forEach(function (card) {
      card.setAttribute('data-ready', '');
      var data; try { data = JSON.parse(card.querySelector('[data-ebf-bn-data]').textContent); } catch (e) { return; }
      var d = card.dataset, t1 = +d.tier1, t2 = +d.tier2, p1 = +d.pct1, p2 = +d.pct2, showFinal = d.final === 'true';
      var rows = card.querySelectorAll('[data-ebf-bn-item]'), imgs = card.querySelectorAll('[data-ebf-bn-img]');
      var chip = card.querySelector('[data-ebf-bn-chip]'), totalEl = card.querySelector('[data-ebf-bn-total]');
      var wasEl = card.querySelector('[data-ebf-bn-total-was]'), savedEl = card.querySelector('[data-ebf-bn-saved]');
      var btn = card.querySelector('[data-ebf-bn-add]');
      var sel = data.items.map(function (p) { return variantById(p, p.selected); });
      var qty = data.items.map(function () { return 1; });
      function paintRow(i) {
        var v = sel[i], row = rows[i], was = row.querySelector('[data-ebf-bn-was]');
        row.querySelector('[data-ebf-bn-now]').textContent = money(v.price * qty[i], data.money);
        var cn = row.querySelector('[data-ebf-bn-color]'); if (cn) cn.textContent = v.color || '';
        was.hidden = !(v.compare > v.price); was.textContent = money(v.compare * qty[i], data.money);
        if (imgs[i]) { setImg(imgs[i].querySelector('img'), v); imgs[i].href = data.items[i].url + '?variant=' + v.id; }
      }
      function render() {
        var sale = 0, reg = 0, ok = true;
        sel.forEach(function (v, i) { sale += v.price * qty[i]; reg += regular(v) * qty[i]; if (!v.available) ok = false; });
        var pct = sale >= t2 ? p2 : (sale >= t1 ? p1 : 0);
        var pay = showFinal ? Math.round(sale * (100 - pct) / 100) : sale;
        var off = reg > pay ? tierLabel(sale, t1, t2, parseFloat(d.basePct), p1, p2) : 0;
        chip.hidden = !+off; chip.querySelector('[data-ebf-bn-pct]').textContent = off;
        var pc = card.querySelector('[data-ebf-bn-pct2]'); pc.hidden = !+off; pc.textContent = off + '% ' + (card.dataset.off || 'off');
        totalEl.textContent = money(pay, data.money);
        wasEl.hidden = !(reg > pay); wasEl.textContent = money(reg, data.money);
        savedEl.hidden = !(reg > pay && d.finalNote); savedEl.textContent = (d.finalNote || '').replace('[amount]', money(reg - pay, data.money));
        btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      }
      rows.forEach(function (row, i) {
        if (!data.items[i]) return;
        var update = swatches(row.querySelector('[data-ebf-bn-sw]'), data.items[i], sel[i], function (v) { sel[i] = v; update(v); paintRow(i); render(); });
        var q = stepper({ cls: 'ebf-qty--row', min: 1, max: 10, value: 1, onChange: function (v) { qty[i] = v; q.set(v); paintRow(i); render(); } });
        row.appendChild(q);
        paintRow(i);
      });
      render();
      btn.addEventListener('click', function () {
        btn.disabled = true;
        addToCart(sel.map(function (v, i) { return { id: v.id, quantity: qty[i] }; }))
          .then(function () {
            btn.classList.add('is-added'); btn.textContent = btn.getAttribute('data-added');
            document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
            setTimeout(openDrawer, 400);
            setTimeout(function () { btn.classList.remove('is-added'); render(); }, 2500);
          })
          .catch(function (err) { btn.disabled = false; btn.textContent = (err && err.description) || btn.getAttribute('data-label'); });
      });
    });
  }

  /* ---------- sideways sliders (single products, bundles): arrows step one card, hide when everything fits ---------- */
  function initSliders(root) {
    root.querySelectorAll('[data-ebf-slider]:not([data-ready])').forEach(function (sl) {
      sl.setAttribute('data-ready', '');
      var track = sl.querySelector('[data-ebf-track]'), prev = sl.querySelector('[data-ebf-prev]'), next = sl.querySelector('[data-ebf-next]');
      function step() { var c = [].filter.call(track.children, function (el) { return !el.hidden; })[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth; }
      function update() {
        var over = track.scrollWidth > track.clientWidth + 2;
        sl.classList.toggle('is-static', !over);
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
      }
      // phones show one card at a time. The row keeps one height, the tallest card's, so the page below never moves
      // while swiping (Hrach, 3 Nov: the height used to follow the card in view and the section under it jumped).
      // It re-measures only when a card itself changes size (fonts, photos, quantity), never on scroll.
      var fitTimer = null;
      // Bundle cards (Hrach, 4 Nov): every card is as tall as the shortest one; a longer list of speakers scrolls inside its
      // card and the price and Add to cart stay at the bottom. Measured from the cards' natural heights.
      function equalCards() {
        var cs = [].filter.call(track.children, function (c) { return !c.hidden && c.matches('[data-ebf-bundle-card]'); });
        if (cs.length < 2) return 0;
        cs.forEach(function (c) { c.style.height = ''; c.classList.remove('is-fixed'); });
        // the height is the tallest of the cards with the fewest speakers, so those never scroll
        var hs = cs.map(function (c) { return Math.ceil(c.getBoundingClientRect().height); });
        var rows = cs.map(function (c) { var l = c.querySelector('.ebf-bundle__items'); return l ? l.children.length : 0; });
        var fewest = Math.min.apply(null, rows), h = 0;
        cs.forEach(function (c, i) { if (rows[i] === fewest) h = Math.max(h, hs[i]); });
        if (Math.max.apply(null, hs) - h < 4) return h;
        cs.forEach(function (c) { c.style.height = h + 'px'; c.classList.add('is-fixed'); cue(c); });
        return h;
      }
      function cue(c) {
        var l = c.querySelector('.ebf-bundle__items'); if (!l) return;
        var more = function () { l.classList.toggle('has-more', l.scrollTop + l.clientHeight < l.scrollHeight - 4); };
        if (!l._cue) { l._cue = true; l.addEventListener('scroll', more, { passive: true }); }
        more();
      }
      function fit() {
        if (!sl.hasAttribute('data-ebf-fit')) return;
        var eq = equalCards();
        if (innerWidth >= 750) { track.style.height = ''; return; }
        var h = eq;
        if (!h) [].forEach.call(track.children, function (c) { if (!c.hidden) h = Math.max(h, Math.ceil(c.getBoundingClientRect().height)); });
        if (h) track.style.height = (h + 24) + 'px';
      }
      function fitSoon() { clearTimeout(fitTimer); fitTimer = setTimeout(fit, 120); }
      if (window.ResizeObserver) { var ro = new ResizeObserver(function () { fit(true); }); [].forEach.call(track.children, function (c) { ro.observe(c); }); }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(true); });
      [].forEach.call(track.querySelectorAll('img'), function (im) { if (!im.complete) im.addEventListener('load', fitSoon, { once: true }); });
      addEventListener('load', function () { fit(true); });
      sl._fit = function () { fit(true); };
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update); addEventListener('resize', fitSoon);
      sl._update = function () { track.scrollLeft = 0; update(); };
      update();
    });
  }

  /* ---------- Loud / Louder / Loudest chips over the single products ---------- */
  function initFilters(root) {
    root.querySelectorAll('[data-ebf-filter-group]:not([data-ready])').forEach(function (g) {
      g.setAttribute('data-ready', '');
      var sec = g.closest('.ebf'), chips = g.querySelectorAll('[data-ebf-filter]'), sl = sec.querySelector('[data-ebf-slider]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          var lv = c.getAttribute('data-ebf-filter');
          chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          sec.querySelectorAll('[data-ebf-card]').forEach(function (card) { card.hidden = card.getAttribute('data-level') !== lv; });
          if (sl && sl._update) sl._update();
        });
      });
    });
  }

  /* ---------- product page upsell: one more speaker towards the extra; + adds it to the cart ---------- */
  function initUpsell(root) {
    root.querySelectorAll('[data-ebf-upsell]:not([data-ready])').forEach(function (box) {
      box.setAttribute('data-ready', '');
      var data; try { data = JSON.parse(box.querySelector('[data-ebf-up-data]').textContent); } catch (e) { return; }
      var d = box.dataset, t1 = +d.tier1, t2 = +d.tier2, p1 = +d.pct1, p2 = +d.pct2;
      var addV = variantById(data.add, data.add.selected), mainV = null;
      var pctEl = box.querySelector('[data-ebf-up-pct]'), textEl = box.querySelector('[data-ebf-up-text]');
      var nowEl = box.querySelector('[data-ebf-up-now]'), wasEl = box.querySelector('[data-ebf-up-was]');
      var link = box.querySelector('[data-ebf-up-link]'), btn = box.querySelector('[data-ebf-up-add]');
      function pageVariant() {
        var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = f ? +f.value : data.main.selected;
        return variantById(data.main, id || data.main.selected);
      }
      function render() {
        var sum = mainV.price + addV.price, pct = sum >= t2 ? p2 : (sum >= t1 ? p1 : 0);
        pctEl.textContent = '+' + (pct || p1);
        textEl.textContent = pct ? 'Add both and get an extra ' + pct + '% off every sale speaker in your cart.'
          : 'Add it and you are ' + money(t1 - sum, data.money) + ' away from an extra ' + p1 + '% off.';
        nowEl.textContent = money(addV.price, data.money);
        wasEl.hidden = !(addV.compare > addV.price); wasEl.textContent = money(addV.compare, data.money);
        setImg(link.querySelector('img'), addV); link.href = data.add.url + '?variant=' + addV.id;
        btn.disabled = !addV.available;
      }
      var q = stepper({ cls: 'ebf-qty--up', min: 0, max: 10, value: 1, onChange: function (v) {
        q.busy(); setCartQty(addV.id, v).then(showQty).catch(function () { showQty(); });
      } });
      q.hidden = true; btn.parentNode.insertBefore(q, btn.nextSibling);
      function showQty() { var n = qtyInCart(addV.id); btn.hidden = n > 0; q.hidden = n === 0; if (n) q.set(n); }
      var update = swatches(box.querySelector('[data-ebf-up-sw]'), data.add, addV, function (v) { addV = v; update(v); render(); showQty(); });
      mainV = pageVariant(); render();
      setInterval(function () { var v = pageVariant(); if (v !== mainV) { mainV = v; render(); } }, 600);  // the theme swaps the variant id without a change event
      btn.addEventListener('click', function () {
        btn.disabled = true;
        setCartQty(addV.id, qtyInCart(addV.id) + 1).then(function () { btn.disabled = false; showQty(); })
          .catch(function (err) { btn.disabled = false; textEl.textContent = (err && err.description) || 'Could not add to cart.'; });
      });
      loadCart().then(showQty);
    });
  }

  /* ---------- "More speakers. More savings." bar: speaker + speakers = sticker, real bundles one after another ---------- */
  function initSteps(root) {
    root.querySelectorAll('[data-ebf-steps]:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '');
      var data; try { data = JSON.parse(sec.querySelector('[data-ebf-sb-data]').textContent); } catch (e) { return; }
      if (!data.bundles.length) return;
      var d = sec.dataset, t1 = +d.tier1, t2 = +d.tier2, p1 = +d.pct1, p2 = +d.pct2;
      var bar = sec.querySelector('[data-ebf-sb-bar]'), dots = sec.querySelector('[data-ebf-sb-dots]');
      var q = function (k) { return bar.querySelector('[data-k="' + k + '"]'); };
      function esc(t) { var x = document.createElement('span'); x.textContent = t; return x.innerHTML; }
      function thumb(p, cls) { var v = variantById(p, p.selected); return '<span class="ebf-sb__thumb ebf-sb__swap ' + (cls || '') + '">' + (v.image ? '<img src="' + v.image + '" alt="">' : '') + '</span>'; }
      // each bundle's prices: sale total less the extra tier, whole saving against the regular price
      var B = data.bundles.map(function (b) {
        var items = [b.main].concat(b.adds), sale = 0, reg = 0;
        items.forEach(function (p) { var v = variantById(p, p.selected); sale += v.price; reg += regular(v); });
        var pct = sale >= t2 ? p2 : (sale >= t1 ? p1 : 0), pay = Math.round(sale * (100 - pct) / 100);
        return { b: b, pay: pay, reg: reg, off: reg > pay ? tierLabel(sale, t1, t2, parseFloat(d.basePct), p1, p2) : 0 };
      });
      if (B.length > 1) B.forEach(function (_, i) { dots.insertAdjacentHTML('beforeend', '<i role="button" tabindex="0" aria-label="Bundle ' + (i + 1) + '"></i>'); });
      var k = 0, paused = false;
      var curIdx = 0, manualAt = 0;
      function show(i) {
        if (typeof i === 'number') k = i;
        curIdx = k;
        var x = B[k], b = x.b;
        cur = x; bar.classList.toggle('is-link', !!bundleCard(b.name));
        q('main').innerHTML = thumb(b.main);
        var st = q('adds'); st.className = 'ebf-sb__stack n' + b.adds.length;
        st.innerHTML = b.adds.map(function (p, i) { return thumb(p, 'd' + (i + 1)); }).join('');
        q('badge').innerHTML = +x.off ? '<span class="ebf-badge ebf-sb__badge ebf-sb__swap d3"><span class="ebf-badge__num">' + x.off + '</span><span class="ebf-badge__unit"><span>%</span><span>' + esc(d.off) + '</span></span></span>' : '';
        q('c1').innerHTML = '<b>' + esc(d.l1) + '</b>' + esc(b.main.title);
        q('c2').innerHTML = '<b>' + esc(d.l2) + '</b><span class="ebf-sb__name">' + esc(b.adds.map(function (a) { return a.title; }).join(', ')) + '</span>';
        q('c3').innerHTML = '<b>' + esc(d.l3.replace('[pct]', x.off)) + '</b><span class="ebf-sb__pay">' + money(x.pay, data.money) + '</span>' +
          (x.reg > x.pay ? ' <s>' + money(x.reg, data.money) + '</s>' : '');
        [].forEach.call(dots.children, function (dot, i) { dot.classList.toggle('on', i === k); });
        k = (k + 1) % B.length;
      }
      // the whole bar leads to its ready-made bundle when one with the same name exists
      function bundleCard(name) { return [].filter.call(document.querySelectorAll('[data-ebf-bundle-name]'), function (c) { return c.getAttribute('data-ebf-bundle-name') === name; })[0]; }
      var cur = null;
      function go() {
        var card = cur && bundleCard(cur.b.name); if (!card) return;
        var track = card.parentNode, sec = card.closest('.ebf-bundles');
        sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (track.scrollTo) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        card.classList.remove('is-flash'); void card.offsetWidth; card.classList.add('is-flash');
        setTimeout(function () { card.classList.remove('is-flash'); }, 1700);
      }
      bar.setAttribute('role', 'link'); bar.tabIndex = 0;
      bar.addEventListener('click', go);
      bar.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      show();
      // slider: arrows, swipe and dots; autoplay waits 10 s after the shopper moves it
      var wrap = sec.querySelector('.ebf-sb__wrap'), n = B.length, swiped = false;
      function manual(i) { manualAt = Date.now(); show(((i % n) + n) % n); }
      if (n > 1) {
        wrap.querySelector('[data-ebf-sb-prev]').addEventListener('click', function (e) { e.stopPropagation(); manual(curIdx - 1); });
        wrap.querySelector('[data-ebf-sb-next]').addEventListener('click', function (e) { e.stopPropagation(); manual(curIdx + 1); });
        [].forEach.call(dots.children, function (dot, i) {
          dot.addEventListener('click', function () { manual(i); });
          dot.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); manual(i); } });
        });
        bar.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') manual(curIdx - 1); if (e.key === 'ArrowRight') manual(curIdx + 1); });
        var sx = null;
        bar.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; swiped = false; }, { passive: true });
        bar.addEventListener('touchend', function (e) {
          if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) { swiped = true; manual(curIdx + (dx < 0 ? 1 : -1)); }
        });
        bar.addEventListener('click', function (e) { if (swiped) { e.stopImmediatePropagation(); swiped = false; } }, true);
        setInterval(function () { if (!paused && !document.hidden && Date.now() - manualAt > 10000) show(); }, (+d.interval || 3) * 1000);
      }
    });
  }

  /* ---------- keep sticky parts just below the site's own sticky menu ---------- */
  function initStickyTop() {
    var root = document.documentElement, ticking = false;
    function header() { var h = document.querySelector('header.header-container, .header-container'); return h; }
    function measure() {
      ticking = false;
      var h = header(), top = 0;
      if (h) { var r = h.getBoundingClientRect(), pos = getComputedStyle(h).position; top = (pos === 'fixed' || pos === 'sticky' || r.top <= 0) ? Math.max(0, Math.round(r.bottom)) : 0; if (r.top > 2) top = 0; }
      root.style.setProperty('--ebf-top', top + 'px');
    }
    function tick() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
    addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); measure();
  }

  /* Product pages, desktop (Hrach, 3 Nov): the builder makes the info column much taller than the photos, which left a
     big empty gap. The photo column now scrolls to its end, then stays in view until the info column ends. */
  function initPdpSticky() {
    var bd = document.querySelector('.ebf-bd--inline'); if (!bd) return;
    var mc = document.querySelector('.product__media-container'), meta = document.querySelector('.product__meta');
    if (!mc || !meta) return;
    function fit() {
      if (window.innerWidth < 960) { mc.style.position = ''; mc.style.top = ''; mc.style.alignSelf = ''; return; }
      var h = document.querySelector('header.header-container, .header-container'), hb = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
      mc.style.position = 'sticky'; mc.style.alignSelf = 'flex-start';
      mc.style.top = Math.min(hb + 16, window.innerHeight - mc.offsetHeight - 16) + 'px';
    }
    fit(); window.addEventListener('resize', fit); window.addEventListener('load', fit);
    if (window.ResizeObserver) new ResizeObserver(fit).observe(mc);
  }
  /* Links to a section on the same page scroll there smoothly, stopping under the sticky header (Hrach, 4 Nov) */
  function initAnchors() {
    if (window.lpEbfAnchors) return; window.lpEbfAnchors = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.ebf a[href^="#"]'); if (!a) return;
      var id = decodeURIComponent(a.getAttribute('href').slice(1)), el = id && document.getElementById(id); if (!el) return;
      e.preventDefault();
      // the header's height once the page has scrolled (it is taller at the very top: 105 px with the bar above, 65 px pinned)
      // (the header block includes the red bar above it, which scrolls away: pinned height = block height - bar height)
      var h = document.querySelector('header.header-container, .header-container'), ub = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--utility-bar-height')) || 0;
      var hb = h ? Math.max(0, h.offsetHeight - ub) : 0;
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + scrollY - hb - 8), behavior: still ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }
  function init() { initCards(document); initCursor(); initAssemble(document); initVideos(document); initBuilder(); initBundles(document); initSliders(document); initFilters(document); initUpsell(document); initSteps(document); initStickyTop(); initPdpSticky(); initAnchors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initCards(e.target); initCursor(); initAssemble(e.target); initVideos(e.target); initBundles(e.target); initSliders(e.target); initFilters(e.target); initUpsell(e.target); initSteps(e.target); });
})();
